


import React from "react";
import "./loadlrcomponent.css";

const PillCloseBtn = ({ onClick }) => (
  <button className="llr-pill-close" onClick={onClick} title="Remove">
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="29" viewBox="0 0 56 29" fill="none">
      <rect x="56" y="29" width="56" height="29" rx="14.5" transform="rotate(180 56 29)" fill="#434343" />
      <path d="M41.9806 10.2104C41.9162 10.1458 41.8396 10.0946 41.7554 10.0596C41.6711 10.0247 41.5807 10.0067 41.4895 10.0067C41.3983 10.0067 41.3079 10.0247 41.2237 10.0596C41.1394 10.0946 41.0629 10.1458 40.9984 10.2104L37.592 13.6098L34.1856 10.2034C34.1211 10.1389 34.0446 10.0878 33.9603 10.0529C33.876 10.018 33.7857 10 33.6945 10C33.6033 10 33.513 10.018 33.4287 10.0529C33.3445 10.0878 33.2679 10.1389 33.2034 10.2034C33.1389 10.2679 33.0878 10.3445 33.0529 10.4287C33.018 10.513 33 10.6033 33 10.6945C33 10.7857 33.018 10.876 33.0529 10.9603C33.0878 11.0446 33.1389 11.1211 33.2034 11.1856L36.6098 14.592L33.2034 17.9984C33.1389 18.0629 33.0878 18.1395 33.0529 18.2237C33.018 18.308 33 18.3983 33 18.4895C33 18.5807 33.018 18.671 33.0529 18.7553C33.0878 18.8396 33.1389 18.9161 33.2034 18.9806C33.2679 19.0451 33.3445 19.0963 33.4287 19.1312C33.513 19.1661 33.6033 19.184 33.6945 19.184C33.7857 19.184 33.876 19.1661 33.9603 19.1312C34.0446 19.0963 34.1211 19.0451 34.1856 18.9806L37.592 15.5742L40.9984 18.9806C41.0629 19.0451 41.1395 19.0963 41.2237 19.1312C41.308 19.1661 41.3983 19.184 41.4895 19.184C41.5807 19.184 41.671 19.1661 41.7553 19.1312C41.8396 19.0963 41.9161 19.0451 41.9806 18.9806C42.0451 18.9161 42.0963 18.8396 42.1312 18.7553C42.1661 18.671 42.184 18.5807 42.184 18.4895C42.184 18.3983 42.1661 18.308 42.1312 18.2237C42.0963 18.1395 42.0451 18.0629 41.9806 17.9984L38.5742 14.592L41.9806 11.1856C42.2453 10.9209 42.2453 10.4751 41.9806 10.2104Z" fill="white" />
    </svg>
  </button>
);

// ─── Display Row ──────────────────────────────────────────────────────────────
const LoadDisplayRow = ({ load, onRemove, onDisplayLoadClick, onEwayAction }) => (
  <div className="llr-load-row">
    <div className="llr-section">
      <div className="llr-section-title">LOAD {load.loadNumber}</div>
      <div className="llr-table-scroll">
        <table className="llr-display-table">
          <thead>
            <tr>
              <th>Party Detail</th>
              <th>From- To Location</th>
              <th>LR Detail</th>
              <th>Item Details</th>
              <th>Eway Details</th>
              <th>Indent Details</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ cursor: "pointer" }} onClick={() => onDisplayLoadClick?.(load.id)}>
              <td><span className="llr-td-party">{load.partyName || "—"}</span></td>
              <td>
                <div className="llr-location-block">
                  <div>
                    <div className="llr-loc-city">{load.fromCity}</div>
                    {(load.fromAddress !== "-" || load.fromContact) && (
                      <div className="llr-loc-sub">{load.fromAddress} | {load.fromContact}</div>
                    )}
                    <div className="llr-loc-sub">Zone- {load.fromZone}</div>
                  </div>
                  <hr className="llr-loc-divider" />
                  <div>
                    <div className="llr-loc-city">{load.toCity}</div>
                    {(load.toAddress !== "-" || load.toContact) && (
                      <div className="llr-loc-sub">{load.toAddress} | {load.toContact}</div>
                    )}
                    <div className="llr-loc-sub">Zone- {load.toZone}</div>
                  </div>
                </div>
              </td>
              <td>
                <div className="llr-lr-grid">
                  <div><div className="llr-field-lbl">LR Date</div><div className="llr-field-val">{load.lrDate}</div></div>
                  <div><div className="llr-field-lbl">Invoice Number</div><div className="llr-field-val">{load.invoiceNumber}</div></div>
                  <div><div className="llr-field-lbl">LR Number</div><div className="llr-field-val">{load.lrNumber}</div></div>
                  <div><div className="llr-field-lbl">MLR Number</div><div className="llr-field-val">{load.mlrNumber}</div></div>
                </div>
              </td>
              <td>
                <div className="llr-item-grid">
                  <span className="llr-item-lbl">KOT</span>
                  <span className="llr-item-val">{load.kot}</span>

                  <span className="llr-item-lbl">QTY</span>
                  {/* ✅ qtyUnit add karo */}
                  <span className="llr-item-val">
                    {load.qty} {load.qty && load.qty !== "-" ? load.qtyUnit : ""}
                  </span>

                  <span className="llr-item-lbl">Sales Value</span>
                  <span className="llr-item-val">{load.salesValue}</span>

                  <span className="llr-item-lbl">Weight</span>
                  {/* ✅ weightUnit add karo */}
                  <span className="llr-item-val llr-item-highlight">
                    {load.weight} {load.weight && load.weight !== "-" ? load.weightUnit : ""}
                  </span>
                </div>
              </td>

              {/* ✅ Eway Details — stopPropagation taaki row click na ho */}
              <td onClick={(e) => e.stopPropagation()}>
                <div className="llr-sub-block">
                  <div>
                    <div className="llr-sub-lbl">
                      Eway Number (Manual)
                      {load.ewayMandatory && (
                        <span style={{ color: "red", marginLeft: 2 }}>*</span>
                      )}
                    </div>

                    {/* {load.hasEwayField ? (
                      // ─── LR saved hai ───────────────────────────────────
                      load.ewayNumber && load.ewayNumber !== "-" ? (
                        <>
                          <div className="llr-sub-val">{load.ewayNumber}</div>
                          <button
                            className="__adxConsignee"
                            style={{ marginTop: 4 }}
                            onClick={(e) => onEwayAction?.(e, load, "edit")}
                          >
                            Edit Eway
                          </button>
                        </>
                      ) : (
                        <button
                          className="__adxConsignee"
                          onClick={(e) => onEwayAction?.(e, load, "add")}
                        >
                          + Add Eway Bill
                          {load.ewayMandatory && (
                            <span style={{ color: "red", display: "inline", opacity: 1 }}>*</span>
                          )}
                        </button>
                      )
                    ) : (
                      // ─── LR save nahi hua — getConsignorDetails se ──────
                      <button
                        className="__advLr_btn"
                        onClick={(e) => onEwayAction?.(e, load, "fetch")}
                      >
                        Add Eway Bill
                        {load.ewayMandatory && (
                          <span style={{ color: "red", display: "inline", opacity: 1 }}>*</span>
                        )}
                      </button>
                    )} */}

                    {load.hasEwayField ? (
                      load.ewayNumber && load.ewayNumber !== "-" ? (
                        <>
                          <div className="llr-sub-val">{load.ewayNumber}</div>
                          <button
                            className="__adxConsignee"
                            style={{ marginTop: 4 }}
                            onClick={(e) => onEwayAction?.(e, load, "edit")}
                          >
                            Edit Eway
                          </button>
                        </>
                      ) : (
                        <button
                          className="__adxConsignee"
                          onClick={(e) => onEwayAction?.(e, load, "add")}
                        >
                          + Add Eway Bill
                          {load.ewayMandatory && (
                            <span style={{ color: "red", display: "inline", opacity: 1 }}>*</span>
                          )}
                        </button>
                      )
                    ) : (
                      // ✅ lr_id nahi — sirf dash, koi button nahi
                      <div className="llr-sub-val">-</div>
                    )}
                  </div>
                  <div>
                    <div className="llr-sub-lbl">Expiry Date</div>
                    <div className="llr-sub-val">{load.ewayExpiryDate}</div>
                  </div>
                </div>
              </td>

              <td>
                <div className="llr-sub-block">
                  <div><div className="llr-sub-lbl">Indent Number</div><div className="llr-sub-val">{load.indentNumber}</div></div>
                  <div><div className="llr-sub-lbl">PO Number</div><div className="llr-sub-val">{load.poNumber}</div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    {!load.originalData?.plan_id?._id && (
      <PillCloseBtn onClick={(e) => { e.stopPropagation(); onRemove(load.id); }} />
    )}
  </div>
);

// ─── Form Row ─────────────────────────────────────────────────────────────────
const LoadFormRow = ({ load, onRemove, onAddExistingLR, onAddMoreDetails, renderFields }) => (
  <div className="llr-load-row">
    <div className="llr-section">
      <div className="llr-section-title">LOAD {load.loadNumber}</div>
      <div className="llr-form-body">
        {renderFields ? renderFields({ load }) : null}
        <div className="llr-form-actions">
          <button className="llr-btn-action" onClick={() => onAddExistingLR?.(load.id)}>
            <span className="llr-btn-icon">+</span>Add From Existing LR
          </button>
          <button className="llr-btn-action" onClick={() => onAddMoreDetails?.(load.id)}>
            <span className="llr-btn-icon">+</span>Add More Details
          </button>
        </div>
      </div>
    </div>
    {!load.originalData?.plan_id?._id && (
      <PillCloseBtn onClick={(e) => { e.stopPropagation(); onRemove(load.id); }} />
    )}
  </div>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const Loadlrcomponent = ({
  loads = [],
  onRemoveLoad,
  onAddMoreLoads,
  onAddExistingLR,
  onAddMoreDetails,
  onDisplayLoadClick,
  onEwayAction,        // ✅ new prop
  renderFields,
}) => (
  <div className="llr-wrapper">
    {loads.map((load) =>
      load.mode === "display" ? (
        <LoadDisplayRow
          key={load.id}
          load={load}
          onRemove={onRemoveLoad}
          onDisplayLoadClick={onDisplayLoadClick}
          onEwayAction={onEwayAction}   // ✅ pass karo
        />
      ) : (
        <LoadFormRow
          key={load.id}
          load={load}
          onRemove={onRemoveLoad}
          onAddExistingLR={onAddExistingLR}
          onAddMoreDetails={onAddMoreDetails}
          renderFields={renderFields}
        />
      )
    )}
    <div className="llr-add-more-bar" onClick={onAddMoreLoads}>
      <span className="llr-plus-circle">+</span>
      ADD MORE LOADS/ LR
    </div>
  </div>
);

export default Loadlrcomponent;